






















































import Vue from "vue";
import ApiService from "@/services/ApiService";
export default Vue.extend({
  data() {
    return {
      email: "",
      password: "",
      loading: false,
    };
  },
  methods: {
    tryLogin() {
      this.$store.dispatch("logout");
      this.loading = true;
      ApiService.generalApi
        .login({
          email: this.email,
          password: this.password,
        })
        .then((response) => {
          this.loading = false;

          if (response.data.user.admin_roles.length == 0) {
            this.$message({
              type: "error",
              message: "Wrong account. Use your admin credentials to login",
            });
          } else {
            this.$store.dispatch("logIn", response.data);
            this.$router.push({ name: "Home" });
          }
        })
        .catch((err) => {
          let errorMessage = "Incorrect login/password";
          if (
            err.response.data &&
            err.response.data.error == "school_disabled"
          ) {
            errorMessage = "School has been disabled";
          }
          this.$message({
            type: "error",
            message: errorMessage,
          });
          this.loading = false;
        });
    },
  }
});
